module.exports = __webpack_public_path__ + "static/media/kitegateway_icon_dark.d9611811.png";